module.exports = __webpack_public_path__ + "static/media/social-butterfly-badge.64ea65b9.svg";